import { Alert, List, Modal, Typography } from 'antd';

import { ACCOUNT_STATUS } from 'utilities/constants';

const { Text } = Typography;

export const FUNDING_ACCOUNT_STATUS_OPTIONS = [
  { value: ACCOUNT_STATUS.DISABLED, label: 'Disable' },
  { value: ACCOUNT_STATUS.ENABLED, label: 'Enable' },
  { value: ACCOUNT_STATUS.NON_OPERATIONAL, label: 'Mark Non-Operational' },
];

const EditFundingAccountsConfirmationModal = ({
  accounts,
  status,
  loading,
  error,
  onConfirm,
  onCancel,
  open,
}) => {
  if (!status) return null;

  const label =
    FUNDING_ACCOUNT_STATUS_OPTIONS.find((option) => option.value === status)
      ?.label || status;

  return (
    <Modal
      title="Confirm Bulk Update"
      open={open}
      onOk={onConfirm}
      onCancel={onCancel}
      okText={label}
      confirmLoading={loading}
    >
      <Text>
        You are about to {label.toLowerCase()} {accounts.length} funding account
        {accounts.length !== 1 ? 's' : ''}:
      </Text>
      <List
        size="small"
        dataSource={accounts}
        renderItem={(account) => (
          <List.Item style={{ padding: '4px 0', border: 'none' }}>
            {account.bankName} - {account.numberLast4} - {account.id}
          </List.Item>
        )}
        style={{ marginTop: 'var(--spacing-sm)' }}
      />
      {error && (
        <Alert
          banner
          type="error"
          message="Some accounts failed to update. Please review and try again."
          style={{ marginTop: 'var(--spacing-sm)' }}
        />
      )}
    </Modal>
  );
};

export default EditFundingAccountsConfirmationModal;
